import PasswordField from './PasswordField';

export default PasswordField;



// WEBPACK FOOTER //
// ./src/components/api/components/PasswordField/index.js